<div class="manage-forecasts-content">
  <div class="page-header">
    <wfm-page-title title="{{'imported.forecasts.page.title' | translate}}"></wfm-page-title>
    <breeze-button *ngIf="hasEspModifyPermission" buttonText="{{'manage.forecasts.import.button.label' | translate}}" id="btn-import-forecasts" [isPrimary]="true" (clicked)="showImportForecastsDlg()"></breeze-button>
  </div>
  <div class="search-box">
    <input-text #searchTextBox inputId="search-text-box" [isSearchField]="true" [isDisabled] = "false"
                [required]="false"
                placeHolderText="{{'imported.forecasts.search.box' | translate}}"
                ariaLabel="{{'imported.forecasts.search.label' | translate}}"
                [announcement]="searchAnnouncement"
                (onTextChangeWithTimeout)="filterRows($event)">
    </input-text>
    <div class="search-actions">
      <ng-template #multiForecastsDelete>
        <div role="dialog"
             aria-labelledby="forecast-delete-title"
             tabindex="-1"
             (keydown.tab)="onForecastDeleteDialogTab($event)"
             (keydown.shift.tab)="onForecastDeleteDialogTab($event)">
          <div class="message-delete">
            <p id="forecast-delete-title">{{'imported.forecasts.delete.multiple' | translate }} </p>
          </div>
          <div class="button-response">
            <breeze-button [isSecondary]="true" [showTooltip] = "false" buttonText="{{'btn.cancel.label' | translate }}" (clicked)="forecastDeletePopover.close()"></breeze-button>
            <breeze-button [isPrimary]="true" [showTooltip] = "false" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="deleteSelectedForecasts()"></breeze-button>
          </div>
        </div>
      </ng-template>
      <div *ngIf="hasEspModifyPermission">
        <breeze-button #forecastDeletePopover="ngbPopover" buttonText="{{'imported.forecasts.label.delete' | translate}}"
                      [isSecondary]="true"
                      [isDisabled]="!hasSelectedImportedForecasts"
                      id="btn-delete"
                      placement="left"
                       tooltipPosition="left"
                      (shown)="focusForecastDeleteDialog()"
                      (hidden)="returnFocusToForecastDeleteBtn()"
                      [ngbPopover]="multiForecastsDelete">
        </breeze-button>
      </div>
    </div>
  </div>
  <div class="imported-forecasts-list table-list">
    <!-- a11y (ESP-18522): row-level open action announced once on grid entry
         via aria-describedby; each cell still announces only its own content. -->
    <p id="forecastGridActivationHelp" class="screenreader-only">{{ 'imported.forecasts.grid.activation.help' | translate }}</p>
    <!-- a11y (ESP-21718 family) / ESP-21806: columns are not draggable at all
         ([suppressMovableColumns]), so there is no column-reorder DOM/Tab-order
         desync to fix and no need for the grid-wide `ensureDomOrder` option
         (whose forced body-row DOM re-splicing on scroll recycle caused stale
         hover / duplicate tooltips during fast scrolling on the plan list grid,
         ESP-21806). -->
    <ag-grid-angular full-width-table
                     [noRowsOverlayComponent]="noRowsOverlayComponent"
                     [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
                     [tableRef]="importedForecastsList"
                     class="ag-theme-balham no-column-borders"
                     (cellClicked)="performCellClick($event)"
                     (cellKeyDown)="onCellKeyDown($event)"
                     (cellFocused)="onCellFocused($event)"
                     (focusout)="onGridFocusOut($event)"
                     rowSelection="multiple"
                     [suppressAutoSize]="true"
                     [rowMultiSelectWithClick]="true"
                     [columnDefs]="columnDefs"
                     [rowData]="rowData"
                     [context]="context"
                     [headerHeight]="45"
                     [suppressMovableColumns]="true"
                     [icons]="icons"
                     [localeText]="gridAriaLocaleText"
                     [suppressRowClickSelection]="true"
                     [defaultColDef]="defaultColDef"
                     #importedForecastsList
                     [components]="frameworkComponents"
                     (gridReady)="onGridReady($event)"
                     (firstDataRendered)="applyCheckboxAriaLabels()"
                     (rowDataUpdated)="applyCheckboxAriaLabels()"
                     (selectionChanged)="applyCheckboxAriaLabels()"
                     (modelUpdated)="applyCheckboxAriaLabels()"
                     [rowClassRules]="rowClassRules"
                     [rowHeight] = "45"
                     [animateRows] ="true"
                     [rowModelType]="rowModelType"
                     [cacheBlockSize]="cacheBlockSize"
                     [infiniteInitialRowCount]="infiniteInitialRowCount"
                     [isRowSelectable]="isRowSelectable"
                     [rowBuffer]="rowBuffer"
                     [loadingOverlayComponent]="loadingOverlayComponent"
                     [enableBrowserTooltips]="true"
                     [suppressAsyncEvents]="true">
    </ag-grid-angular>
  </div>
</div>
<p-toast position="bottom-right">
</p-toast>

<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
  <symbol id="icon-rectangle" viewBox="0 0 21 21">
    <title>rectangle</title>
    <path d="M0 0v20h20v-20h-20zM18.333 18.333h-16.667v-16.667h16.667v16.667z"></path>
  </symbol>
  <symbol id="icon-multi-choices" viewBox="0 0 21 21">
    <title>multi-choices</title>
    <path d="M0 0v20h20v-20h-20zM18.333 18.333h-16.667v-16.667h16.667v16.667z"></path>
    <path fill="#007CBE" d="M15.5 6.917l-1.333-1.333-5.917 5.917-2.167-2.917-1.583 1.083 3.5 4.75z"></path>
  </symbol>
  <symbol id="icon-rect-disabled" viewBox="0 0 24 24">
    <title>rect-disabled</title>
    <path d="M0 0v20h20v-20h-20zM18.333 18.333h-16.667v-16.667h16.667v16.667z"></path>
  </symbol>
  <symbol id="icon-sort-ascending" viewBox="0 0 20 20">
    <path d="M6.1 13.1c0.3 0 0.5-0.1 0.7-0.3l3.2-3.2 3.2 3.2c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4l-3.9-3.9c-0.1-0.1-0.2-0.2-0.3-0.2-0.2-0.1-0.5-0.1-0.8 0-0.1 0-0.2 0-0.3 0.1l-3.9 3.9c-0.4 0.4-0.4 1 0 1.4 0.2 0.3 0.4 0.4 0.7 0.4z"></path>
  </symbol>
  <symbol id="icon-sort-descending" viewBox="0 0 20 20">
    <path d="M13.2 7.2l-3.2 3.2-3.2-3.2c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4l3.9 3.9c0.1 0.1 0.2 0.2 0.3 0.2 0.1 0.1 0.3 0.1 0.4 0.1s0.3 0 0.4-0.1c0.1-0.1 0.2-0.1 0.3-0.2l3.9-3.9c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0z"></path>
  </symbol>
  <symbol id="icon-sort">
    <path d="M6.1 8.1c0.3 0 0.5-0.1 0.7-0.3l3.2-3.2 3.2 3.2c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4l-3.9-3.9c-0.1-0.1-0.2-0.2-0.3-0.2-0.2-0.1-0.5-0.1-0.8 0-0.1 0-0.2 0-0.3 0.1l-3.9 4c-0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.4 0.3 0.7 0.3z"></path>
    <path d="M13.2 12.2l-3.2 3.2-3.2-3.2c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4l3.9 3.9c0.1 0.1 0.2 0.2 0.3 0.2 0.1 0.1 0.3 0.1 0.4 0.1s0.3 0 0.4-0.1c0.1-0.1 0.2-0.1 0.3-0.2l3.9-3.9c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0z"></path>
  </symbol>
</svg>
